import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, Paper } from '@mui/material';
import FlightTakeoffIcon from '@mui/icons-material/FlightTakeoff';
import { STATION_LIST } from '../config/stationConfigs';

const StationSelect = () => {
  const navigate = useNavigate();

  return (
    <Box sx={{
      minHeight: 'calc(100vh - 64px)',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      color: '#fff',
      position: 'relative',
      zIndex: 1,
      px: 2
    }}>
      <Typography variant="h4" sx={{
        fontWeight: 700,
        color: '#C0C0C0',
        mb: 1,
        textAlign: 'center'
      }}>
        Select Station
      </Typography>
      <Typography variant="body1" sx={{
        color: 'rgba(255, 255, 255, 0.5)',
        mb: 5,
        textAlign: 'center'
      }}>
        Choose a station to manage pier belt assignments
      </Typography>

      <Box sx={{
        display: 'flex',
        gap: 4,
        flexWrap: 'wrap',
        justifyContent: 'center'
      }}>
        {STATION_LIST.map((station) => (
          <Paper
            key={station.code}
            onClick={() => navigate(`/piers/${station.code}`)}
            sx={{
              p: 4,
              width: 280,
              cursor: 'pointer',
              bgcolor: 'rgba(255, 255, 255, 0.05)',
              backdropFilter: 'blur(10px)',
              WebkitBackdropFilter: 'blur(10px)',
              border: '1px solid rgba(255, 255, 255, 0.1)',
              borderRadius: 3,
              textAlign: 'center',
              transition: 'all 0.3s',
              '&:hover': {
                bgcolor: 'rgba(249, 182, 18, 0.08)',
                borderColor: 'rgba(249, 182, 18, 0.4)',
                transform: 'translateY(-4px)',
                boxShadow: '0 8px 32px rgba(249, 182, 18, 0.15)'
              }
            }}
          >
            <FlightTakeoffIcon sx={{
              fontSize: 48,
              color: '#F9B612',
              mb: 2
            }} />
            <Typography variant="h3" sx={{
              fontWeight: 700,
              color: '#F9B612',
              mb: 1
            }}>
              {station.code}
            </Typography>
            <Typography variant="h6" sx={{
              color: '#C0C0C0',
              fontWeight: 500,
              mb: 0.5
            }}>
              {station.name}
            </Typography>
            <Typography variant="body2" sx={{
              color: 'rgba(255, 255, 255, 0.5)'
            }}>
              {station.description}
            </Typography>
          </Paper>
        ))}
      </Box>
    </Box>
  );
};

export default StationSelect;
